import {Component, ElementRef, ViewChild} from '@angular/core';
import {AlertController, ModalController, NavController, NavParams, PopoverController} from 'ionic-angular';

import { ConferenceData } from '../../../providers/conference-data';
import {MissionsData} from "../../../providers/missions-data";
import {MissionsFilterPage} from "../missions-filter/missions-filter";
import {MissionsPostulatePage} from "../missions-postulate/missions-postulate";
import {UserData} from "../../../providers/user-data";
import {LocationViewer} from "../../utils/location-viewer/location-viewer"
import {SupportPage} from "../../support/support";
import {MessagingPopover} from "../../support/popover";
import {MissionCandidateDetailPopover} from "../missions-candidate/missions-candidate-detail/popover";
import {MissionsCandidateDetailPage} from "../missions-candidate/missions-candidate-detail/missions-candidate-detail";
import {Observable} from "rxjs/Observable";
import * as moment from "moment";


@Component({
    selector: 'page-mission-detail',
    templateUrl: 'mission-detail.html'
})
export class MissionDetailPage {

    mission: any;
    segment: any;
    alreadyRegistered: any;
    scroll: any = 100;
    stickyShown: boolean = false;
    @ViewChild('stickyHeader') stickyHeader: ElementRef;
    constructor(
        public missionsData: MissionsData,
        public navParams: NavParams,
        public modalCtrl: ModalController,
        public userData: UserData,
        public navCtrl: NavController,
        public popoverCtrl: PopoverController,
        public alertCtrl: AlertController
    ) {



    }

    ionViewDidLoad() {

        this.segment = "job";
        this.alreadyRegistered = false;
        this.getUserInfos();

    }

    getUserInfos() {

        var that = this;

        that.userData.userSession().subscribe(session => {
            if(session!==null)
            {
                that.userData.load().subscribe(user => {
                    /*that.missionsData.load("all").subscribe((data: any) => {
                        for(let i=0;i<data.length;i++){

                            if(data[i].id == that.navParams.data.missionId)
                            {
                                that.mission = data[i];
                            }
                        }
                        if(that.mission)
                            that.alreadyRegistered = that.userData.get('missionCandidates/'+that.mission.id);
                    });*/
                    that.missionsData.getMission(that.navParams.data.missionId).subscribe((data: any) => {
                        that.mission = data;
                        if(that.mission)
                            that.alreadyRegistered = that.userData.get('missionCandidates/'+that.mission.id);
                    });

                });
            }
        });
    }
    openPostulate()
    {
        let modal = this.modalCtrl.create(MissionsPostulatePage, {missionId: this.mission.id});
        modal.present();

        modal.onWillDismiss((data: any[]) => {
            this.getUserInfos();
        });
    }
    postulate()
    {
        /** Check if user is available **/
        var contracts = this.userData.get('missionContracts');

        var available = true;
        var postulateStart = moment(this.mission.start,'DD/MM/YY');
        var postulateEnd = moment(this.mission.end,'DD/MM/YY');
        var contractKeys = Object.keys(contracts);
        for(let i=0;i<contractKeys.length;i++)
        {
            var key = contractKeys[i];
            var contract = contracts[key];
            if(contract.status=="signed" || contract.status=="counter-signed")
            {
                var contractStart = moment(contract.mission.start,'DD/MM/YY');;
                var contractEnd = moment(contract.mission.end,'DD/MM/YY');

                if(
                    (postulateStart.unix()>=contractStart.unix() && postulateStart.unix()<=contractEnd.unix()) ||
                    (postulateEnd.unix()>=contractStart.unix() && postulateEnd.unix()<=contractEnd.unix()) ||

                    (contractStart.unix()>=postulateStart.unix() && contractStart.unix()<=postulateEnd.unix()) ||
                    (contractEnd.unix()>=postulateStart.unix() && contractEnd.unix()<=postulateEnd.unix())
                )
                {
                    available = false;

                }
            }
        }
        if(available)
        {
            this.openPostulate();
        }
        else {
            var that = this;
            let prompt = this.alertCtrl.create({
                title: 'Non disponibilité',
                message: 'Vous avez déjà un contrat en cours sur la période allant du '+this.mission.start+' au '+this.mission.end+'. Vous ne pouvez pas signer plusieurs mission sur la même période.',
                buttons: [
                    {
                        text: 'Ok',
                        handler: data => {

                        }
                    }
                ]
            });
            prompt.present();
        }
    }
    gotoCandidate(offer)
    {
        var that = this;

        if(that.alreadyRegistered)
            this.navCtrl.push(MissionsCandidateDetailPage, { missionId: that.mission.id, name: that.mission.name });
    }
    goSupport()
    {
        this.navCtrl.push(SupportPage, { missionId: this.mission.id, prefix: "A propos de la \""+this.mission.name+"\" (ref."+this.mission.id+") : " });
    }
    seeMap()
    {
        let modal = this.modalCtrl.create(LocationViewer, {mission: this.mission,searchFilters:this.userData.get('searchFilters')});
        modal.present();

        modal.onWillDismiss((data: any[]) => {
        });
    }

    presentPopover(event: Event) {
        let popover = this.popoverCtrl.create(MissionCandidateDetailPopover,
            {
                support: true,
                locate: true,
            });
        var that = this;
        popover.onDidDismiss(data => {

            if(data == 'support')
            {
                that. goSupport();
            }
            if(data == 'locate')
            {
                that.seeMap();
            }
        });
        popover.present({ ev: event });
    }
    onScroll(event)
    {
        this.scroll=event.scrollTop;
        if(this.scroll>100 && !this.stickyShown) {
            this.stickyShown = true;

            this.stickyHeader.nativeElement.classList.add("show");
            this.stickyHeader.nativeElement.style.display='block';
        }
        else if(this.scroll<=100 && this.stickyShown)
        {
            this.stickyShown = false;
            this.stickyHeader.nativeElement.classList.remove("show");
        }

    }

}



// WEBPACK FOOTER //
// ./src/pages/missions/mission-detail/mission-detail.ts